import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

import Box from '../components/Box'

import { authLogin } from '../actions/auth'

import LoginForm from '../forms/LoginForm'

class LoginPromoterView extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
    this.success = this.success.bind(this)
  }

  submit(props) {
    return this.props.authLogin(props, false, true)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  success(result) {
    this.props.push('/')
  }

  render() {
    return (
      <div className="h-100 bg-login">
        <div className="container h-100">
          <div className="row justify-content-center align-items-center h-100">
            <div className="col pc">
              <div className="text-center mb-3">
                <img className="" src="/images/one_render.png" alt="VACWAYlockers" style={{ width: '50%' }} />
              </div>
            </div>
            <div className="col">
              <div className="text-center mb-3">
                <img className="login_logo" src="/images/logo.svg" alt="Logo" />
              </div>
              <div className="text-center mb-5">
                <h2 className="text-white">ONE & MINI</h2>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div style={{
                  width: '60%',
                  paddingLeft: '20px',
                  paddingRight: '20px',
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  borderRadius: '40px',
                  background: 'linear-gradient(45deg, #044D8B,rgb(235, 133, 0))',
                  color: '#ffffff'
                }} className='d-flex align-items-center justify-content-center mb-3'>
                  <img className="login_shield mr-3" src="/images/shield.png" alt="Admin" />
                  <h5 className="text-white mb-0">MODO PROMOTOR ACTIVADO</h5>
                </div>
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <LoginForm onSubmit={this.submit}
                  onSubmitSuccess={this.success}
                  isAdmin={false} />
              </div>
              <div className="d-flex justify-content-center mt-5">
                <div className="w-50 text-center">
                  <p className="text-white">Síguenos</p>
                  <div className="d-flex justify-content-between gap-4 flex-wrap mt-3">
                    <a href="https://vacway.com/es?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/www.png" alt="Web" />
                    </a>
                    <a href="https://es.linkedin.com/company/vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/linkedin.png" alt="LinkedIn" />
                    </a>
                    <a href="https://www.instagram.com/vacway/?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/instagram.png" alt="Instagram" />
                    </a>
                    <a href="https://www.tiktok.com/@vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/tiktok.png" alt="TikTok" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  authLogin: bindActionCreators(authLogin, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(() => ({}), mapDispatchToProps)(LoginPromoterView)
